import React from "react"
import Select from "react-select"
import PropTypes from "prop-types"

import "./dropdown.scss"

const Dropdown = (props) => {
  let {
    label,
    options,
    selectAll,
    defaultValue,
    onChange,
    onInputChange,
    onMenuScrollToBottom,
    inputValue,
    isMulti,
    isSearchable,
    filterOption,
    value,
  } = props

  options = options.map(({ value, name }) => ({ value, label: name }))

  if (selectAll) {
    options = [{ value: "", label: "All" }, ...options]
  }

  if (!value) {
    value = options[0]
  }

  if (defaultValue) {
    value = options.find(({ value }) => value === defaultValue)
  }

  if (isMulti && value && !(value instanceof Array)) {
    value = [value]
  }

  let selectConfig = {
    value,
    options,
    onChange,
    onInputChange,
    onMenuScrollToBottom,
    inputValue,
    isMulti,
    isSearchable,
    filterOption,
  }

  if (selectAll) {
    selectConfig.isClearable = true
    selectConfig.clearValue = { value: "", label: "All" }
  }

  return (
    <div className="dropdown-container" data-cy={props["data-cy"]}>
      {label && <label>{label}</label>}
      <div className="select-container">
        <Select {...selectConfig} />
      </div>
    </div>
  )
}

const optionType = PropTypes.shape({
  value: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
})

Dropdown.propTypes = {
  label: PropTypes.string,
  selectAll: PropTypes.bool,
  isSearchable: PropTypes.bool,
  defaultValue: PropTypes.any,
  options: PropTypes.arrayOf(optionType),
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  isMulti: PropTypes.bool,
  onMenuScrollToBottom: PropTypes.func,
  inputValue: PropTypes.string,
  filterOption: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
  ]),
}

export default Dropdown
